var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"show-add-button":false,"sort":"id","descending":true,"title":"Queued Jobs","icon":"mdi-comment-processing","stateendpoint":"queuedJobLogs.queuedJobLogs","actions":_vm.actions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }